import { navbarWidths } from '../Layout/Navbar/config';

export type LayoutMode = 'phone' | 'tablet' | 'desktop';
export type NavbarState = 'collapsed' | 'expanded';

// Phone <768px; tablet rail 768–1279px; desktop >=1280px.
export const LAYOUT_BREAKPOINTS = Object.freeze({ tablet: 768, desktop: 1280 });
export const LAYOUT_MEDIA_QUERIES = Object.freeze({
  tablet: `(min-width: ${LAYOUT_BREAKPOINTS.tablet}px)`,
  desktop: `(min-width: ${LAYOUT_BREAKPOINTS.desktop}px)`
});

// Copy existing widths without freezing or mutating the legacy configuration.
export const NAVBAR_WIDTHS = Object.freeze({
  expanded: navbarWidths.expanded,
  collapsed: navbarWidths.collapsed
});

export const getLayoutMode = (viewportWidth: number): LayoutMode => {
  if (viewportWidth >= LAYOUT_BREAKPOINTS.desktop) return 'desktop';
  if (viewportWidth >= LAYOUT_BREAKPOINTS.tablet) return 'tablet';
  return 'phone';
};

// Transient phone drawer/tablet expansion never changes content's reserved width.
export const getOccupiedNavbarWidth = (mode: LayoutMode, preference: NavbarState): number => {
  if (mode === 'phone') return 0;
  if (mode === 'tablet') return NAVBAR_WIDTHS.collapsed;
  return preference === 'expanded' ? NAVBAR_WIDTHS.expanded : NAVBAR_WIDTHS.collapsed;
};

// Independent Header and Navbar React roots communicate through window CustomEvents.
export const NAVBAR_DRAWER_REQUEST_EVENT = 'navbar:drawerRequest';
export interface NavbarDrawerRequestDetail {
  action: 'open' | 'toggle';
}

export const NAVBAR_DRAWER_STATE_CHANGE_EVENT = 'navbar:drawerStateChange';
export interface NavbarDrawerStateDetail {
  open: boolean;
}

// Preserve the existing string detail ('collapsed' | 'expanded') for legacy listeners.
export const NAVBAR_STATE_CHANGE_EVENT = 'navbar:stateChange';

// Header owns the trigger; Navbar returns focus to it on drawer dismissal.
// Header sets aria-controls to NAVBAR_DRAWER_ID and aria-expanded from drawer state.
export const NAVBAR_MENU_TRIGGER_ID = 'navbar-menu-trigger';
export const NAVBAR_DRAWER_ID = 'navbar-mobile-drawer';

export const LAYOUT_Z_INDEX = Object.freeze({
  drawer: 1300,
  drawerPopup: 1301,
  aiModal: 1400
});

// Light surface: use existing WHITE, SCOUT_BLUE, LIGHT_TEAL, DARK_TEAL,
// SCOUT_TEAL and BORDER from ThemeContext/constants. Teal accents are not body text.
// The navbar keeps the original dark palette: WHITE text on SCOUT_BLUE, teal gradient header.

// Onboard publishes this after every resolved route, including query/hash-only changes.
export const LAYOUT_ROUTE_CHANGE_EVENT = 'layout:routeChange';

// Header crumbs from a router or a page: detail `{ items: BreadcrumbItem[] | null }`, where
// `null` restores the crumbs the server rendered. Both Header implementations listen for it.
export const BREADCRUMB_UPDATE_EVENT = 'breadcrumb:update';
